export default __webpack_public_path__ + "static/media/Group.5becca51.svg";